import SentryFeedbackButton from "@/components/ui/SentryFeedbackButton";

export function SiteHeader({ title = "Dashboard" }: { title?: string }) {
  return (
    <header className="flex h-12 shrink-0 items-center border-b px-4 lg:px-6 justify-between">
      <div className="flex items-center gap-2">
        <h1 className="text-base font-medium">{title}</h1>
      </div>
      <SentryFeedbackButton />
    </header>
  );
}
